export const EQUIPMENT_INDEX = 0
export const PRICE_INDEX = 1
export const MAX_PRICE_INDEX = 2

export const EQUIPMENT_FORM_ID = 'equipment-form'
